import { render } from "./Contabilizacion.vue?vue&type=template&id=d33c07fa"
import script from "./Contabilizacion.vue?vue&type=script&lang=js"
export * from "./Contabilizacion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__